import { Button, Card, CopyButton, Text, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { setup_names } from "../util";
import useVersion from "../hooks/useVersion";
import { FaCheck, FaCopy, FaRegCopy } from "react-icons/fa";

const DownloadChecksum = ({os, algorithm}: {os: string, algorithm: string}) => {

    const [checksum, setChecksum] = useState<string | null>(null);
    const version = useVersion();

    useEffect(() => {
        if (!version) return;
        const filename = setup_names[os as keyof typeof setup_names].replace("VERSION", version);
        fetch(`https://api.stacher.io/api/checksum/${filename}/${algorithm}`)
            .then(res => res.json())
            .then(data => {
                setChecksum(data.checksumValue);
            })
            .catch(err => {
                setChecksum(null);
            });
    }, [version, os, algorithm]);

    if (!checksum || !version) {
        return null;
    }
    return (
        <Card>
            <Text fw="bold" size="sm">
                Operating System: {os}
            </Text>
            <Text fw="bold" size="sm">
                File Name: {setup_names[os as keyof typeof setup_names].replace("VERSION", version)}
            </Text>
            <Text fw="bold" size="sm">
                Checksum Algorithm: {algorithm.toUpperCase()}
            </Text>
            <TextInput
                value={checksum}
                variant="transparent"
                label={<Text size="xs" c="dimmed">Checksum:</Text>}
                readOnly
                style={{ marginTop: "10px" }}
                rightSection={
                    <CopyButton value={checksum}>
                        {({ copied, copy }) => (
                            <Button
                                variant="transparent"
                                style={{
                                    padding: "5px 10px",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    color: copied ? "#4caf50" : "#ffffff",
                                    border: "none",
                                    borderRadius: "4px"
                                }}
                                onClick={copy}
                            >
                                {copied ? <FaCheck/> : <FaRegCopy />}
                            </Button>
                        )}
                    </CopyButton>
                }
            />
        </Card>
    )

}

export default DownloadChecksum;